import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Check } from 'lucide-react';
const CHECKOUT_URL = 'https://spanish-teacher-ready.impultienda.ar/checkout';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-black relative overflow-hidden" data-id="element-91" data-mp="c7k4vvuvkjnt">
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold-dark/10 via-black to-black pointer-events-none" data-id="element-92" data-mp="84xl8i8cy51p"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-93" data-mp="h659e7h5tpi2">
        <div className="text-center mb-16" data-id="element-94" data-mp="h5lpil7y8r1e">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-95" data-mp="vv9q1k8b3lo2">
            Next Monday you can keep building your Spanish lessons from
            scratch...
            <br data-id="element-96" data-mp="14vg2d2s9qfln" />
            <span className="text-gold-gradient" data-id="element-97" data-mp="14uwt0agoozj8">
              Or you can walk in with everything ready — starting today.
            </span>
          </h2>

          <div className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-navy-card p-8 rounded-2xl border border-navy-border" data-id="element-98" data-mp="zua6wx784e8f">
            {['No more Sunday nights searching for activities that work together', 'No more lessons that feel rushed or improvised', 'No more students losing motivation because the sessions feel repetitive', 'No more weekends spent planning instead of living', 'No more walking in wishing you had prepared more'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-99" data-mp="301tzugd38i4l" data-mpi={i}>
                <span className="text-gold mt-1" data-id="element-100" data-mp="30096uv6f978u">▸</span>
                <span className="text-gray-300" data-id="element-101" data-mp="34un2myozxge1">{item}</span>
              </div>)}
          </div>

          <p className="text-xl text-white mb-2" data-id="element-102" data-mp="39rvphcl3a8lm">
            Spanish Teacher Ready™ does not make you a better teacher.
          </p>
          <p className="text-2xl font-bold text-gold mb-6" data-id="element-103" data-mp="3it39cpmuz6w6">
            You are already a great teacher.
          </p>
          <p className="text-xl text-gray-300 mb-16" data-id="element-104" data-mp="1jntq7q1unrw8">
            What Spanish Teacher Ready™ does is give you the time and the tools
            to make that visible in every single class you teach.
          </p>
        </div>

        <div className="bg-black border-2 border-gold/30 rounded-3xl p-8 md:p-12 shadow-[0_0_40px_rgba(212,175,55,0.1)]" data-id="element-105" data-mp="1shgktcubmp3u">
          <h3 className="text-2xl font-bold text-white mb-6 text-center border-b border-navy-border pb-6" data-id="element-106" data-mp="1nong2oyurgrr">
            Everything that's included:
          </h3>

          <div className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-107" data-mp="1xeoroha0r6ps">
            {['120 ready-to-teach Spanish lessons', 'Organized progressively for Spanish 1 and Spanish 2', '40+ weeks of fresh, non-repeating content', 'Every lesson completely structured', 'Learning objectives, vocabulary, grammar, activities & assessments', 'Bonus 1 — Spanish Grammar Made Simple', 'Bonus 2 — 100 Conversation Activities', 'Bonus 3 — Assessment and Quiz Bank', 'Bonus 4 — 30 Culture Lessons', 'Bonus 5 — 30 Emergency Lessons', '7-day money-back guarantee', 'Immediate access', 'Pay in your local currency', 'PDF format — ready to use'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-108" data-mp="3u8ax48uoqgzl" data-mpi={i}>
                <Check size={18} className="text-gold shrink-0" data-id="element-109" data-mp="3fbtkzfeo8ybz" />
                <span className="text-sm text-gray-200" data-id="element-110" data-mp="3kcpxghd39st0">{item}</span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-111" data-mp="36e00r2u6lv56">
            <div className="mb-8 p-6 bg-gold/5 rounded-xl border border-gold/20 italic text-gray-300 text-lg" data-id="element-112" data-mp="36f1bt7b76hmw">
              "The best time to have this teaching system was before your first
              class.
              <br data-id="element-113" data-mp="19kelt29aszao" />
              <span className="text-gold font-bold not-italic" data-id="element-114" data-mp="19ky4il6rvrpr">
                The second best time is today.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold text-white mb-2" data-id="element-115" data-mp="35l6yedly5lbv">
              📚 Spanish Teacher Ready™
            </p>
            <p className="text-sm text-gray-400 mb-8" data-id="element-116" data-mp="2vou5hhy87bi6">
              120 ready-to-teach Spanish lessons created to help teachers plan
              less, teach with confidence and keep every class fresh.
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={() => {
            if (typeof window !== 'undefined' && (window as any).fbq) {
              ;
              (window as any).fbq('track', 'InitiateCheckout', {
                content_name: 'Spanish Teacher Ready Complete System',
                value: 27.0,
                currency: 'USD'
              });
            }
          }} className="w-full md:w-auto text-xl py-6 px-12 mb-6" data-id="element-117" data-mp="2mpqku9jeuo1k">
              🟡 GET THE COMPLETE TEACHING SYSTEM NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-gray-500" data-id="element-118" data-mp="egsigzijuly0">
              <span data-id="element-119" data-mp="jeln3o47f7w6">✅ 7-day money-back guarantee</span>
              <span data-id="element-120" data-mp="ni068nnfw4du">✅ Secure payment</span>
              <span data-id="element-121" data-mp="ni9w8b8hibjj">✅ Immediate access</span>
              <span data-id="element-122" data-mp="sguui546el5c">✅ Pay in your local currency</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}